import Croppie from 'croppie'
export default class UploadThumb {
  constructor(thumb, width) {
    if (thumb) {
      const allowedTypes = ['png', 'jpg', 'jpeg', 'gif', 'JPG']
      const token = document.querySelector('form input[name="_token"]').getAttribute('value')
      const method = document.querySelector('form input[name="_method"]').getAttribute('value')
      const uploader = document.getElementById('uploader')
      const fileInput = document.querySelector('#thumb')
      const area = document.querySelector('.thumb_area')
      const uploadCrop = document.createElement('div')
      const urlPostImg = document.querySelector('.main_content_form-thumb').getAttribute('action')
      const urlRedirect = document.querySelector('.main_content_form-thumb #url').getAttribute('data-value')
      this.width = width
      const crop = new Croppie(uploadCrop, {
        viewport: { width: 248, height: 240 },
        showZoomer: false,
        enableOrientation: true
      })

      fileInput.addEventListener('change', function (e) {
        area.innerHTML = ''
        const file = e.target.files[0]
        const reader = new FileReader()
        let imgType = file.name.split('.')
        imgType = imgType[imgType.length - 1]
        reader.onload = function (e) {
          area.append(uploadCrop)
          crop.bind({
            url: e.target.result
          })
        }
        reader.readAsDataURL(file)

        uploader.addEventListener('click', function (e) {
          e.preventDefault()
          if (allowedTypes.indexOf(imgType) !== -1) {
            uploadAjax(this.width)
          } else {
            alert('Format non reconnu')
          }
        })
      })

      const uploadAjax = function (width) {
        crop.result({
          type: 'canvas',
          size: { width },
          quality: 0.75,
          format: 'jpeg'
        }).then(function (resp) {
          const xhr = new XMLHttpRequest()
          const send = XMLHttpRequest.prototype.send
          XMLHttpRequest.prototype.send = function (data) {
            this.setRequestHeader('X-CSRF-Token', token)
            return send.apply(this, arguments)
          }
          xhr.onreadystatechange = function () {
            if (xhr.readyState === 4) {
              setTimeout(function () {
                document.location.href = urlRedirect
              }, 500)
            }
          }
          const form = new FormData()

          form.append('thumb', resp)
          form.append('method', method)

          xhr.open('post', urlPostImg, true)
          xhr.send(form)
        })
      }
    }
  }
}
